import { ToggleButton } from '@mui/material';
import { styled } from '@mui/system';

export const OZCustomToggleButton = styled(ToggleButton, {
    shouldForwardProp: prop => (prop !== 'selectionFollowsFocus' && prop !== 'textColor' && prop !== 'indicator')
})(props => ({

}))